import cn from 'classnames';
import type { ComponentPropsWithRef, FunctionComponent } from 'react';
import style from './Button.module.scss';

interface Props extends ComponentPropsWithRef<'button'> {
  variant?: 'primary' | 'secondary' | 'ghost';
  loading?: boolean;
}

export const Button: FunctionComponent<Props> = ({
  variant = 'primary',
  loading = false,
  disabled,
  className,
  type = 'button',
  ...props
}) => (
  <button
    {...props}
    type={type}
    disabled={loading || disabled}
    aria-busy={loading || undefined}
    className={cn(style.button, style[variant], loading && style.loading, className)}
  />
);
